var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    fill: "#26479D",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.16a83 83 0 0 1 4.85.07c1.3.06 2.65.36 3.6 1.31.97.96 1.26 2.3 1.32 3.61a83 83 0 0 1 .07 4.85 83 83 0 0 1-.07 4.85c-.06 1.3-.37 2.66-1.31 3.6-.97.97-2.3 1.26-3.61 1.32-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.29-.06-2.67-.37-3.6-1.31-.96-.96-1.26-2.3-1.32-3.61A83 83 0 0 1 2.16 12a83 83 0 0 1 .07-4.85c.06-1.3.37-2.66 1.31-3.6.96-.97 2.3-1.26 3.61-1.32A83 83 0 0 1 12 2.16M12 0C8.74 0 8.33.01 7.05.07c-1.85.09-3.7.6-5.04 1.94C.67 3.36.16 5.2.07 7.05A85.62 85.62 0 0 0 0 12c0 3.26.01 3.67.07 4.95.09 1.85.6 3.7 1.94 5.04 1.35 1.34 3.19 1.85 5.04 1.94 1.28.06 1.7.07 4.95.07 3.26 0 3.67-.01 4.95-.07 1.85-.09 3.7-.6 5.04-1.94 1.34-1.35 1.85-3.19 1.94-5.04.06-1.28.07-1.7.07-4.95 0-3.26-.01-3.67-.07-4.95-.09-1.85-.6-3.7-1.94-5.04C20.64.67 18.79.16 16.95.07A85.62 85.62 0 0 0 12 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.84a6.16 6.16 0 1 0 0 12.32 6.16 6.16 0 0 0 0-12.32zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.41,
    cy: 5.59,
    r: 1.44
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.d269b4fd1b418a37a39029fc1e3e27c7.svg";
export { ForwardRef as ReactComponent };